// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonIdentityPicker = {
  treeTitle: "Organization",
  treeSearchPlaceholder: "Search organizations",
  treeLoading: "Loading organizations",
  treeEmpty: "No organizations available",
  tableTitlePrefix: "Users",
  selectOrganization: "Please select an organization",
  organizationNode: "Organization Unit",
  selectedUsersTitle: "Selected Members",
  selectedUsersEmpty: "No members selected",
  pickMembersFromOrganization: "Pick members from organization",
  emptyInCurrentScope: "No members can be added in the current organization scope",
  emptyBeforeOrganization: "Select an organization first",
  loadDataFailed: "Failed to load organization picker data",
  missingMembershipListApi: "Failed to load organization members: membership list API is missing",
  loadMembersFailed: "Failed to load organization members",
  loadUserDetailsFailed: "Failed to load user details",
  searchField: "Search {field}",
  columns: {
    allOrganizationMemberships: "All Organization Memberships",
  },
  actions: {
    remove: "Remove",
  },
} as const;
